import { PORTAL_TUTORIAL_TARGETS, type PortalTutorialTargetId } from './portal-tutorial-targets.const'

export type PortalTutorialStepDefinition = {
  target: PortalTutorialTargetId
  translationKey: string
}

export const PORTAL_TUTORIAL_STEPS: PortalTutorialStepDefinition[] = [
  { target: PORTAL_TUTORIAL_TARGETS.PORTAL_NAV, translationKey: 'portal' },
  { target: PORTAL_TUTORIAL_TARGETS.ADD_NEW, translationKey: 'addNew' },
  { target: PORTAL_TUTORIAL_TARGETS.SERVICE_MAP, translationKey: 'serviceMap' },
  { target: PORTAL_TUTORIAL_TARGETS.GRAFTS, translationKey: 'grafts' },
  { target: PORTAL_TUTORIAL_TARGETS.VISION_NAV, translationKey: 'vision' },
  { target: PORTAL_TUTORIAL_TARGETS.MODULES_NAV, translationKey: 'modules' },
  { target: PORTAL_TUTORIAL_TARGETS.GATEWAY_NAV, translationKey: 'gateway' },
  { target: PORTAL_TUTORIAL_TARGETS.INSIGHTS_NAV, translationKey: 'insights' },
  { target: PORTAL_TUTORIAL_TARGETS.ACADEMY_NAV, translationKey: 'academy' },
]

export const PORTAL_TUTORIAL_TOTAL_STEPS = PORTAL_TUTORIAL_STEPS.length
